import { inject, IReactComponent, observer } from 'mobx-react';

export function bindToMobx<P = {}, T extends IReactComponent = IReactComponent>(
	dataSource: (rootStore: any, nextProps: any, context: any) => any,
	target: T
) {
	return inject(dataSource)(observer(target)) as IReactComponent<P>;
}
